import api from './../../service/api';
import routes from "../../service/apiRoutes";

export const makeLogin = (data) => api.post(routes.login, data, {noauth: true});
export const makeLoginWithToken = (data) => api.post(routes.loginWithToken, data, {noauth: true});
export const getProfile = () => api.get("/user", {noRedirectOnError: true});